import { Link, useSearchParams } from 'react-router-dom';
import DelayLink from '../DelayLink/index'
import React, { useState, useEffect } from 'react';
import styles from './css/Style.module.css';
import { ShowPopUpConfirmationV2 } from '../PopUp';
import { RenderSinoNotificacoes } from '../Link_sino_notificacoes';
import { utils_iam_iframe } from '../utils/utils_iam_iframe';


function NavBarSimples({ Titulo, BackPage, NavDestacada = false, allowIconNotification = true }) {

    const [searchParams, setSearchParams] = useSearchParams();
    const disableNav = searchParams.get('disableNav');
    /*
    * REGION POP UP
    */
    const [statePopUpOpen, setStatePopUpOpen] = useState(false);
    const [statePopUpMsg, setstatePopUpMsg] = useState('');
    const [statePopUpCallback, setstatePopUpCallback] = useState(null);
    const [statePopUpIgnore_confirmation, setstatePopUpIgnore_confirmation] = useState(false);
    function ShowAlertView(msg, callback = null, ignore_confirmation = false) {
        setStatePopUpOpen(true)
        setstatePopUpMsg(msg);
        if (callback !== null) {
            setstatePopUpCallback(() => {
                return () => {
                    callback();
                }
            });
            setstatePopUpIgnore_confirmation(ignore_confirmation);
        }
    }
    /*
    * END
    */
    useEffect(() => {
        return () => {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, []);

    const [state, setState] = useState(false);
    const [stateUrlParamIsBackGround, setStateUrlParamIsBackGround] = useState(null);
    useEffect(() => {
        if (!state)
            setState(true);
        else {
            window.scrollTo({ top: 0, behavior: 'instant' });
            const page_running_back_ground = getURLParam('page_running_back_ground');
            setStateUrlParamIsBackGround(page_running_back_ground);
            const backBtn = document.getElementById('back_btn_nav_bar_control');
            if (backBtn !== null && !stateUrlParamIsBackGround) {
                backBtn.addEventListener("click", function (e) {
                    if (backBtn.name != '') {
                        e.preventDefault();
                        ShowAlertView("Deseja descartar as alterações?", () => {
                            const back_btn_nav_bar_control_internal = document.getElementById("back_btn_nav_bar_control_internal");
                            if (back_btn_nav_bar_control_internal !== null)
                                back_btn_nav_bar_control_internal.click();
                        })
                    }
                });
            }
        }

    }, [state]);
    function getURLParam(param) {
        let parametros = window.location.href.split('?');
        if (parametros.length > 1) {
            parametros = parametros[1].split('&');
            for (let i = 0; i < parametros.length; i++) {
                const parametro = parametros[i].split(param + '=');
                if (parametro.length == 2)
                    return parametro[1];
            }
            return parametros;
        }
        return null
    }
    if (disableNav) { return null }
    return (
        !utils_iam_iframe && <>
            {statePopUpOpen ? <ShowPopUpConfirmationV2 msg={statePopUpMsg} closePopup={() => setStatePopUpOpen(false)} callback={statePopUpCallback} ignore_confirmation={statePopUpIgnore_confirmation} /> : null}
            <header className={`${styles.container_geral_navbar_simples}`}>
                <nav className={`${styles.top_nav}`}>
                    <ul style={{ backgroundColor: !NavDestacada ? "white" : "#dc4a03" }}>
                        {
                            stateUrlParamIsBackGround !== null ? <li>
                                <a className={`${styles.nav_icon} ${!NavDestacada ? styles.nav_icon_back : styles.nav_icon_back_2}`} name="internal_background_close_page">&nbsp;&nbsp;&nbsp;&nbsp;</a>
                                <a className={!NavDestacada ? styles.black_color : styles.white_color} style={{ marginLeft: "10px" }} name="internal_background_close_page" >{Titulo}</a>
                            </li> : <li>
                                <DelayLink to={-1} className={`${styles.nav_icon} ${!NavDestacada ? styles.nav_icon_back : styles.nav_icon_back_2}`} id="back_btn_nav_bar_control">&nbsp;&nbsp;&nbsp;&nbsp;</DelayLink>
                                <Link to={-1} className={!NavDestacada ? styles.black_color : styles.white_color} style={{ marginLeft: "10px" }} id="back_btn_nav_bar_control_2" >{Titulo}</Link>
                                <Link to={-1} style={{ marginLeft: "10px", display: "none" }} id="back_btn_nav_bar_control_internal">{Titulo}</Link>
                            </li>
                        }
                        <li className={styles.nav_center}></li>
                        {
                            allowIconNotification && <RenderSinoNotificacoes style_pagina_principal={false} NavDestacada={NavDestacada} />
                            // allowIconNotification && <RenderSinoNotificacoes style_pagina_principal={true} /> <li>
                            //     <a className={`${styles.nav_icon} ${styles.nav_icon_bell}`}>&nbsp;&nbsp;&nbsp;&nbsp;</a>
                            // </li>
                        }
                        <Link to={-1} style={{ display: "none" }} id="JS_INTERNAL_APP_BACK"></Link>
                    </ul>
                </nav>
                <hr />
            </header>
            <div className={`${styles.container_externo_geral_navbar_simples} ${styles.top_nav_bottom_space}`}></div>
        </>
    );
}
export default NavBarSimples; 